import { Children, type PropsWithChildren } from "react";
import Box from "@mui/material/Box";
import { when } from "util/support";
import { useStep } from "../hooks";

const Stepper = ({ children }: PropsWithChildren) => {
    const { isCurrentStep } = useStep();

    return (
        <Box
            sx={{
                display: 'grid',
                gap: 1
            }}
        >
            {Children.map(children, (step, index) => (
                <Box
                    key={index}
                    sx={{
                        ...when(
                            isCurrentStep(index + 1),
                            {
                                bgcolor: 'primary.main',
                                color: 'primary.contrastText',
                                fontWeight: 'bold'
                            }
                        ),
                        borderRadius: .7
                    }}
                >
                    {step}
                </Box>
            ))}
        </Box>
    );
};

export default Stepper;
